import 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody, ModalFooter } from 'play/molecules/modal/Modal';

interface RestartModalProps {
  open: boolean;
  onClose?: () => void;
  onRestart?: () => void;
}

export const RestartModal = ({ open, onClose, onRestart }: RestartModalProps) => (
  <Modal title="Do you want to restart?" width="medium" onClose={onClose} open={open}>
    <ModalBody>
      This will drop the current progress. You can’t undo this. You will have to start from the beginning.
    </ModalBody>

    <ModalFooter>
      <Button variant="outline" tw="mr-2" onClick={onClose}>
        Cancel
      </Button>

      <Button onClick={onRestart} data-testid="confirm-restart">
        Restart
      </Button>
    </ModalFooter>
  </Modal>
);
